var _path, _path2, _path3, _rect, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSimulatorImprovedHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 13.2495V27.9995C5 28.2647 5.10536 28.5191 5.29289 28.7066C5.48043 28.8942 5.73478 28.9995 6 28.9995H12V20.4995C12 20.1017 12.158 19.7202 12.4393 19.4389C12.7206 19.1575 13.1022 18.9995 13.5 18.9995H18.5C18.8978 18.9995 19.2794 19.1575 19.5607 19.4389C19.842 19.7202 20 20.1017 20 20.4995V28.9995H26C26.2652 28.9995 26.5196 28.8942 26.7071 28.7066C26.8946 28.5191 27 28.2647 27 27.9995V13.2495",
    stroke: "#666F7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 16.0011L16.6806 3.25111C16.3681 2.92111 15.6375 2.91736 15.3194 3.25111L2 16.0011",
    stroke: "#666F7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11.1873V3.99976H22V8.31226",
    stroke: "#666F7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.52344 8C1.52344 4.42326 4.42326 1.52344 8 1.52344C11.5767 1.52344 14.4766 4.42326 14.4766 8C14.4766 11.5767 11.5767 14.4766 8 14.4766C4.42326 14.4766 1.52344 11.5767 1.52344 8Z",
    fill: "#00B74F",
    stroke: "#666F7A",
    strokeWidth: 0.046875
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.80005L8 5.30005M8 5.30005L10.5 7.80005M8 5.30005V10.8",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulatorImprovedHome);
export default __webpack_public_path__ + "static/media/SimulatorImprovedHome.375b2f1b.svg";
export { ForwardRef as ReactComponent };